import { render } from "./name.vue?vue&type=template&id=1d568f75&scoped=true&ts=true"
import script from "./name.vue?vue&type=script&lang=ts"
export * from "./name.vue?vue&type=script&lang=ts"

import "./name.vue?vue&type=style&index=0&id=1d568f75&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d568f75"]])

export default __exports__